import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';

// Só a aba ativa fica montada. Trocar de aba refaz as chamadas à API dos cards,
// o que é intencional por enquanto: manter as abas inativas montadas e apenas
// escondidas deformava os gráficos do MUI X, que medem a largura do container.
export function DashboardTabPanel({ index, activeTab, children }) {
  if (activeTab !== index) return null;

  return (
    <Box role="tabpanel" sx={{ pt: 3 }}>
      {children}
    </Box>
  );
}

DashboardTabPanel.propTypes = {
  index: PropTypes.number.isRequired,
  activeTab: PropTypes.number.isRequired,
  children: PropTypes.node,
};

DashboardTabPanel.defaultProps = {
  children: null,
};
